/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import { usePaylink } from '../../../../providers/Paylink.provider';
import useStorage from '../../../../hooks/useStorage';
import { useLayout } from '../../../../providers/Layout.provider';
import { CrossRiverP2C } from './CrossRiverP2C';
import { useAccessTokenFields } from '../../../../providers/AccessToken.provider';
import usePostLinkPushToCardRequest from '../../../../hooks/useApi/usePostLinkPushToCardRequest';
import { useHistoryFields } from '../../../../providers/History.provider';
import { useToken } from '../../../../providers/Token.provider';

const { IframeLayout, SeparatorMoon, SeparatorImg, Image } = vp;

type FC = FunctionComponent;

type DataProps = {
  method: string;
  origin: string;
};

const CrossRiverPushToCardContainer: FC = () => {
  const { layout, color, src, height, positionX, positionY, setLayoutInfo } = useLayout();
  const { Token } = usePaylink();
  const storage = useStorage();
  const IframeKey = storage.token.getIQ11Token().iQ11Token;
  const { accessToken } = useAccessTokenFields();
  const { state } = useLocation<DataProps>();
  const [iFrameUrl, setIFrameUrl] = useState<string>('');
  const crossRiverRequestId = uuidv4();
  const [pushToCardMapResponse, callLinkPushToCardRequest] = usePostLinkPushToCardRequest({});
  const [requestId, setRequestId] = useState<string>('');
  const { setLayoutRedirect } = useHistoryFields();
  const { token, isSetByBrowser } = useToken();
  const hasBackButton = !(isSetByBrowser && token?.PaymentSelectionMethod === 'debitcard');

  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      hasBackButton,
      false,
    );
  }, []);

  useEffect(() => {
    if (accessToken !== '') {
      setRequestId(crossRiverRequestId);
      setLayoutRedirect(false);
    }
  }, [accessToken]);

  useEffect(() => {
    if (requestId !== '') {
      localStorage.setItem('state', JSON.stringify(state));

      callLinkPushToCardRequest({
        IframeKey,
        Token,
        RequestID: requestId,
        IsPayLinkTransaction: state?.origin === 'token',
      });
    }
  }, [requestId]);

  useEffect(() => {
    if (pushToCardMapResponse.Success) {
      setIFrameUrl(pushToCardMapResponse.PushToCardDetails.IframeUrl);
      localStorage.setItem('pushToCardMapResponse', JSON.stringify(pushToCardMapResponse));
    }
  }, [pushToCardMapResponse]);

  return iFrameUrl !== '' ? (
    <IframeLayout
      separator={
        layout === 'img' ? (
          <SeparatorImg width={100} height={110} fill={color} />
        ) : layout === 'moon' ? (
          <SeparatorMoon width={140} height={110} fill={color} />
        ) : (
          <></>
        )
      }
      image={
        src === '' ? (
          <></>
        ) : (
          <Image width="auto" height={height} positionX={positionX} positionY={positionY} src={src} />
        )
      }
      hasBackButton={hasBackButton}
      content={<CrossRiverP2C iFrameUrl={iFrameUrl} />}
    />
  ) : (
    <div />
  );
};

export default CrossRiverPushToCardContainer;
